var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46863 0.375732H5.53113C5.44779 0.375732 5.40613 0.417399 5.40613 0.500732V5.40698H0.750244C0.666911 5.40698 0.625244 5.44865 0.625244 5.53198V6.46948C0.625244 6.55282 0.666911 6.59448 0.750244 6.59448H5.40613V11.5007C5.40613 11.5841 5.44779 11.6257 5.53113 11.6257H6.46863C6.55196 11.6257 6.59363 11.5841 6.59363 11.5007V6.59448H11.2502C11.3336 6.59448 11.3752 6.55282 11.3752 6.46948V5.53198C11.3752 5.44865 11.3336 5.40698 11.2502 5.40698H6.59363V0.500732C6.59363 0.417399 6.55196 0.375732 6.46863 0.375732Z",
    fill: "#001B3B",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.46fe288abfff3dd948a6858f196e9a09.svg";
export { ForwardRef as ReactComponent };